import { render, staticRenderFns } from "./adicionarAtendimento.vue?vue&type=template&id=7f712407"
import script from "./adicionarAtendimento.ts?vue&type=script&lang=js&external"
export * from "./adicionarAtendimento.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f712407')) {
      api.createRecord('7f712407', component.options)
    } else {
      api.reload('7f712407', component.options)
    }
    module.hot.accept("./adicionarAtendimento.vue?vue&type=template&id=7f712407", function () {
      api.rerender('7f712407', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/atendimento/atendimentos/adicionarAtendimento/adicionarAtendimento.vue"
export default component.exports